import { graphql } from 'gatsby'
import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"

const title = "talentfactoryFM | About"

export default ({ data }) => {
  return (
    <Layout>
  <div>
      <Helmet title={title} />
      <h1>
          About
      </h1>
      <p>
        I'm a Swiss-Argentine based football manager addict and I like goats. Do you like goats too?
      </p>
      <p>
        No in all seriousness, I'm a former information technology student and apart from FM I am interested in Graphic and Web Design.
      </p>
      <p>
       You can find me on FMSlack on my channel <strong>#nestorfm</strong>. Feel free to contact me on any of these platforms, or just use the form below
      </p>
         <form
          name="contact"
          method="post"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="contact" />
          <p hidden>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>
          <p>
            <label>
              Your name<br />
              <input type="text" name="name" />
            </label>
          </p>
          <p>
            <label>
              Your email<br />
              <input type="email" name="email" />
            </label>
          </p>
          <p>
            <label>
              Message<br />
              <textarea name="message" />
            </label>
          </p>
          <p>
            <button type="submit">Send</button>
          </p>
</form>
  </div>
  </Layout>
)}

export const query = graphql`
  query AboutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`
